import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Question", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Réponse", -1)
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_vue_collapsible_panel = _resolveComponent("vue-collapsible-panel")!
  const _component_vue_collapsible_panel_group = _resolveComponent("vue-collapsible-panel-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      "is-home": false,
      title: "Questions sur le dépannage",
      icon: "message-circle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Tabs, { tabsList: _ctx.TabsList }, null, 8, ["tabsList"]),
      _createVNode(_component_vue_collapsible_panel_group, {
        accordion: "",
        class: "faqs-accordion"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Faqs, (faq, i) => {
            return (_openBlock(), _createBlock(_component_vue_collapsible_panel, {
              expanded: false,
              key: i,
              onClick: ($event: any) => (_ctx.openQuestion(faq.title))
            }, {
              title: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("span", {
                  class: "bold-title",
                  innerHTML: faq.title
                }, null, 8, _hoisted_3)
              ]),
              content: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", {
                  innerHTML: faq.content
                }, null, 8, _hoisted_5)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}